import { CART_SHEET_EVENTS, dispatchCartSheetEvent } from "../utils/eventUtils";

/**
 * Opens the cart widget sheet
 */
export function openCart(): void {
  dispatchCartSheetEvent(CART_SHEET_EVENTS.OPEN_CART);
}

/**
 * Closes the cart widget sheet
 */
export function closeCart(): void {
  dispatchCartSheetEvent(CART_SHEET_EVENTS.CLOSE_CART);
}

/**
 * Toggles the cart widget sheet open/closed state
 */
export function toggleCart(): void {
  dispatchCartSheetEvent(CART_SHEET_EVENTS.TOGGLE_CART);
}
